
		import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "dreamland/jsx-runtime";
export const title = "Dude, Where’s My Touch Bar?";
export const description = "In defense of Apple’s most hated hardware feature.";
export const image = "/blog-images/touchbar.gif";
export const tags = ["Opinion", "Rant"];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    img: "img",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/touchbar.gif",
        alt: "MacBook Pro with Touch Bar"
      })
    }), "\n", _jsx("cap", {
      children: _jsxs("subt", {
        children: [_jsx("span", {
          class: "material-symbols",
          children: "info"
        }), "Image Credit: ", _jsx(_components.a, {
          href: "https://www.apple.com/ca/newsroom/2020/05/apple-updates-13-inch-macbook-pro-with-magic-keyboard-double-the-storage-and-faster-performance/",
          children: "Apple"
        })]
      })
    }), "\n", _jsx(_components.p, {
      children: "Before I moved onto my current 16\" MacBook Pro with an M4 Pro, I used to daily drive the 4-port variant of the 2020 13\" MacBook Pro. Being the last model of Intel Mac ever produced, it obviously became a hot mess (literally! the idle temperature was 80ºC) which is why I made the move. One thing I did miss however, was the Touch Bar."
    }), "\n", _jsx(_components.p, {
      children: "For the uninitiated, from 2016 to 2020, certain Mac notebooks ditched the standard function row for a small touchscreen OLED, which could change its software buttons and controls based on the context of the current app. This choice quickly became a controversial one with many power users complaining that it ruined muscle memory. This concern was actually addressed in the Touch Bar's original implementation, with an always-present software escape key (which was later replaced with a physical one in the 2019 and 2020 models to create a very nice hybrid approach) and the ability to display the classic function keys instead of the app-dependent controls."
    }), "\n", _jsx(_components.p, {
      children: "Now, I actually used the app-dependent mode, and I actually quite liked it! It was really useful in apps that supported it, and didn't really get in the way when I didn't need it. There was an option to change the mode on a per-app basis, so when I used an app that didn't support the Touch Bar and made heavy use of the function keys, I could force it to display those keys all the time."
    }), "\n", _jsx(_components.p, {
      children: "In the end, I did end up adjusting to the return to hardware keys on my new MacBook. But something inside me still yearns for that, even if unorthodox, cool little differentiating feature."
    })]
  });
}
export function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}


		export default function Page() {
			const {wrapper: MDXLayout} = this.components || ({});
			return (
				MDXLayout 
					? _jsx(MDXLayout, { children: [_createMdxContent(this)], ...this })
					: _createMdxContent(this)
			)
		}
	